import { Navigate, Outlet, useLocation } from 'react-router-dom';

function AppLayout() {
  const location = useLocation();

  if (location.pathname == '/account') {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="container">
      <Outlet />
    </main>
  );
}

export default AppLayout;
